export default __webpack_public_path__ + "static/market-index-treemap-fbdf082e3919a7d10266cd7af1f625ca.png";